import ConfirmationWithBackButton from 'src/components/Compliance/ConfirmationWithBackButton';
import MessageBox from 'src/components/Compliance/MessageBox';
import BadgeImg from '../../../assets/images/FramedImage.png';
import Logomark from '../../../assets/images/Logomark.png';

const UploadSuccess = () => {
  return (
    <ConfirmationWithBackButton
      title="Thanks you for uploading your policy"
      subtitle="We will contact you and your property manager after reviewing."
      image={BadgeImg}
      goBackLink="/compliance/welcome"
      message=
        <MessageBox
          image={Logomark}
          title="Still have question?"
        />
    />
  );
};

export default UploadSuccess;
